/**
 * El campo trampa de los formularios publicos (lib/antispam/servidor.ts).
 *
 * Una persona no lo ve ni llega a el con el tabulador; un programa que rellena
 * todos los campos que encuentra, si. Se llama `sitio_web` porque es de los que
 * los programas de spam rellenan siempre.
 */
export const NOMBRE_CAMPO_TRAMPA = "sitio_web"

export function CampoTrampa() {
  return (
    <div aria-hidden="true" className="absolute left-[-9999px] top-auto h-px w-px overflow-hidden">
      <label>
        No rellenar
        <input type="text" name={NOMBRE_CAMPO_TRAMPA} tabIndex={-1} autoComplete="off" defaultValue="" />
      </label>
    </div>
  )
}
